/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-undef */
const config = {
  NODE_ENV: process.env.NODE_ENV,
  dev: process.env.NODE_ENV === 'development',
  prod: process.env.NODE_ENV === 'production',
  test: process.env.NODE_ENV === 'test',
  debug: process.env.DEBUG || false,
  baseName: process.env.BASENAME || '',
  api: process.env.API_URL || 'https://api.dev.blaze.me/',
  apiFS: process.env.FEATURE_SERVICE_API_URL || 'https://gateway.staging.blaze.me/feature/',
  report_api: process.env.REPORT_API || 'https://api.dev.blaze.me/',
  import_api: process.env.IMPORT_API_URL || 'https://admin.import.staging.blaze.me/',
  ga4ID: process.env.GA4_ID || 'G-1Z9Z9B8VKJ',
  stripePK: process.env.stripePK || 'pk_test_AEL7yfcOpRn4OfAISb5Mg0oj',
  distributionUrl: process.env.DISTRIBUTION_URL,
  retailUrl: process.env.RETAIL_URL,
  growSalesUrl: process.env.GROW_SALES_URL,
  growOperationsUrl: process.env.GROW_OPERATIONS_URL,
  dispatchUrl: process.env.DISPATCH_URL,
  ms_dispatchUrl: process.env.MS_DISPATCH_URL,
  apiFB: process.env.API_FB || false,
  sentryDSN: process.env.SENTRY_DSN,
  version: process.env.VERSION,
  posUrl: process.env.POS_URL || `https://pos.staging.blaze.me`,
  userpilotToken: process.env.USERPILOT_TOKEN || '',
  isSSOEnabled: process.env.SSO_ENABLED === 'true',
  storeWidgetURL: '',
  storeFrontURL: 'https://store.dev.blaze.me',
  platformAPI: '',
  sentrySampleRate: 1.0,
}

switch (config.api) {
  case 'https://api.blaze.me/':
    config.storeWidgetURL = 'https://store.blaze.me'
    config.platformAPI = 'https://gateway.blaze.me'
    break
  case 'https://api.stage.blaze.me/':
    config.storeWidgetURL = 'http://35.173.237.217:8083'
    config.platformAPI = 'https://gateway.staging.blaze.me'
    break
  case 'http://api.dev.blaze.me/':
    config.storeWidgetURL = 'http://dev.blaze.me:8081'
    config.storeFrontURL = 'https://dist-store.dev.blaze.me'
    config.platformAPI = 'https://gateway.staging.blaze.me'
    break
  case 'https://api.dev.blaze.me/':
    config.storeWidgetURL = 'https://dev.blaze.me:8081'
    config.storeFrontURL = 'https://dist-store.dev.blaze.me'
    config.platformAPI = 'https://gateway.staging.blaze.me'
    break
  default:
    config.platformAPI = 'https://gateway.staging.blaze.me'
    break
}

if (config.prod) {
  config.sentrySampleRate = 0.2
} else {
  config.sentrySampleRate = 1.0
}

export default config



// WEBPACK FOOTER //
// ./src/config/config.ts